export enum HubMode {
  program = 'program',
  space = 'space',
}

export { HubMode as LearnspaceMode }